import React, { memo, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import {
  Container,
  MainCard,
  ContentContainer,
  TextSection,
  Title,
  CardsContainer,
  AccountTypeCard,
  CardInner,
  CardLabel,
  ButtonGroup,
} from "./RegistrationStartStep.elements";
import { PersonalIcon } from "./PersonalIcon";
import { CompanyIcon } from "./CompanyIcon";
import { ButtonGhost, ButtonPrimary } from "../Button/Button";

export type AccountType = "individual" | "business";

interface RegistrationStartStepProps extends WithTranslation {
  onNext?: (accountType: AccountType) => void;
  onBack?: () => void;
}

export function RegistrationStartStep({
  t,
  onNext,
  onBack,
}: RegistrationStartStepProps) {
  const [selectedAccountType, setSelectedAccountType] =
    useState<AccountType | null>(null);
  const handleAccountTypeSelect = (type: AccountType) => {
    setSelectedAccountType(type);
  };

  const handleNext = () => {
    if (selectedAccountType) {
      if (onNext) {
        onNext(selectedAccountType);
      }
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  return (
    <Container>
      <MainCard>
        <ContentContainer>
          <TextSection>
            <Title>{t('registration.title')}</Title>
          </TextSection>

          <CardsContainer>
            <AccountTypeCard
              onClick={() => handleAccountTypeSelect("individual")}
            >
              <CardInner selected={selectedAccountType === "individual"}>
                <PersonalIcon/>
              </CardInner>
              <CardLabel selected={selectedAccountType === "individual"}>
                {t('registration.individual')}
              </CardLabel>
            </AccountTypeCard>
            <AccountTypeCard
              onClick={() => handleAccountTypeSelect("business")}
            >
              <CardInner selected={selectedAccountType === "business"}>
                <CompanyIcon />
              </CardInner>
              <CardLabel selected={selectedAccountType === "business"}>
                {t('registration.business')}
              </CardLabel>
            </AccountTypeCard>
          </CardsContainer>
        </ContentContainer>

        <ButtonGroup>
          <ButtonGhost onClick={handleBack}>{t('common.button.back')}</ButtonGhost>
          <ButtonPrimary disabled={!selectedAccountType} onClick={handleNext}>
            {t('common.button.next')}
          </ButtonPrimary>
        </ButtonGroup>
      </MainCard>
    </Container>
  );
}

export default withTranslation()(memo(RegistrationStartStep));
